const config = require('./config.base')

if (window.__ENVIRONMENT__ === 'recette') {
  config.qobuzapi = {
    app_id: '712109809',
    app_secret: '589be88e4538daea11f509d29e4a23b1',
    base_port: '80',
    base_url: 'https://www.qobuz.com',
    base_method: '/api.json/0.2/'
  }
} else {
  config.qobuzapi = {
    app_id: '712109809',
    app_secret: '589be88e4538daea11f509d29e4a23b1',
    base_port: '80',
    base_url: 'https://www.qobuz.com',
    base_method: '/api.json/0.2/'
  }
}

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./config/config.production.js
// module id = 286
// module chunks = 0